export default __webpack_public_path__ + "static/media/magnic2.3bad6fdc.png";